module.exports = __webpack_public_path__ + "img/new_55.b4e84bc9.jpg";